module.exports = __webpack_public_path__ + "img/sup_kyc_2.4fd7c50b.jpg";